import Vue from 'vue'
import types from '@/store/mutation-types'

const defaultState = getDefaultState()

function getDefaultState () {
  return {
    allTablesInfo: {},
    pageNum: 1,
  }
}

// getters
const getters = {
  getTableInfoById: state => tableId => state.allTablesInfo[tableId],
  pageNum: state => state.pageNum,
}

const actions = {
  /**
   * Keep `filterConditions` / order on the cached blob; clear row snapshot so CommonTable
   * does not hydrate from stale `tableContentLists` when parent list props are empty temporarily.
   */
  purgeContentListSnapshot ({ getters, commit }, { tableId }) {
    if (tableId == null || String(tableId).trim() === '') return
    const prev = getters.getTableInfoById(tableId)
    if (!prev) return
    commit(types.TABLE_SET_TABLE_INFO, {
      ...prev,
      tableId,
      tableContentLists: [],
    })
  },

  /** Remove entire cached CommonTable blob (filters, row snapshot, order, scroll). Call when navigating away via menu. */
  removeTableUiCache ({ commit }, { tableId }) {
    if (tableId == null || String(tableId).trim() === '') return
    commit(types.TABLE_REMOVE_TABLE_INFO, { tableId })
  },
}

// mutations
const mutations = {
  [types.TABLE_SET_TABLE_INFO] (state, tableInfo) {
    state.allTablesInfo[tableInfo.tableId] = tableInfo
    return state
  },
  [types.TABLE_REMOVE_TABLE_INFO] (state, { tableId }) {
    if (tableId == null || String(tableId).trim() === '') return state
    if (Object.prototype.hasOwnProperty.call(state.allTablesInfo, tableId)) {
      Vue.delete(state.allTablesInfo, tableId)
    }
    return state
  },
  [types.TABLE_SET_PAGE_NUMBER] (state, value) {
    state.pageNum = value
    return value
  },
  [types.RESET_STATE] (state) {
    state.allTablesInfo = {}
    state.pageNum = 1
    return state
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
}
